type Link = {
    text: string,
    href: string,
};

type ImageLink = {
    alt: string,
    href: string,
    src: string,
};

export interface FooterState {
    linksSection: {
        title: string,
        links: Array<Link>,
    } | null
    socialSection: {
        title: string,
        imageLinks: Array<ImageLink>,
    } | null,
    appsSection: {
        title: string,
        imageLinks: Array<ImageLink>,
    } | null,
    bottomFooterBar: {
        year: number,
        rightsReservedText: string,
        poweredByLink: Link,
    },
}

export const footerReducer = (state:FooterState = {} as FooterState, action:{type:string}) => {
  switch (action.type) {
    default:
      return state;
  }
};
